<!--
  TODO - Split should only be available on the last element of the flow
-->

<template>
  <ValidationObserver
    ref="SplitObserver" >
    <template
      v-if="pathsCount" >
      <div class="warning-note flex flex-align-center">
        <span class="emoji-fix mr-2">⚠️</span>
        <p>Only the first path that meets the conditions set below will be triggered</p>
      </div>
      <div
        v-for="(x, index) in pathsCount"
        :key="x"
        class="path" >
        <div
          v-if="index"
          class="SB-border bottom mt-3 mb-3" />
        <h3>Path {{ index + 1 }}</h3>
        <ValidationProvider
          ref="replyValidationProviderRef"
          name="Field"
          :rules="{
            validChild: true,
          }" >
          <FilterBlock
            v-model="filterModel[pathsCount[index]]"
            class="no-label"
            :force-remove-icon="pathsCount.length > 2"
            @removeLast="removePath(index)" />
        </ValidationProvider>
      </div>
    </template>

    <div class="SB-border bottom mt-3 mb-3" />

    <span
      class="add-path flex flex-align-center action"
      :class="{ disabled: pathsCount.length === flowsDefinitionsUI.logic.SPLIT.limits.max_child_flows }"
      @click.stop="addPath" >
      <SBIcon
        :icon="SBIconList.PLUS"
        :color="SBColors.blackPrimary"
        class="p-0 m-0 mr-2"
        :border-radius="0"
        :size="8" />
      Add path</span>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import randomString from '@/helpers/randomString';
import FilterBlock from './FilterBlock';

export default {
  name: 'SplitBlock',
  components: {
    SBIcon,
    FilterBlock,
  },
  data() {
    return {
      pathsCount: [1, 2],
      nextPathId: 3,
      filterModel: {},
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      flowsDefinitionsUI: 'flows/flowsDefinitionsUI',
    }),
  },
  methods: {
    ...mapActions({
      addFlowBlock: 'flows/addFlowBlock',
    }),
    addPath() {
      if (this.pathsCount.length < this.flowsDefinitionsUI.logic.SPLIT.limits.max_child_flows) {
        this.pathsCount.push(this.nextPathId++);
      }
    },
    removePath(index) {
      const key = this.pathsCount[index];
      this.pathsCount.splice(index, 1);
      delete this.filterModel[key];
    },
    submit(parentId) {
      if (this.$refs.SplitObserver.validate()) {
        const blocks = [];
        Object.values(this.filterModel).forEach((v, index) => {
          blocks.push({
            blocks: [{
              ...v.value.block,
              order: index,
            }],
          });
        });

        this.addFlowBlock({
          parentId,
          block: {
            category: 'logic',
            type: 'SPLIT',
            params: {
              split_number: Object.keys(this.filterModel).length,
            },
            child_flows: blocks,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              this.$emit('finished');
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-path {
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.05);
  border: solid 1px $greyBorder;
  padding: 5px 13px 4px 10px;
  background-color: $white;
  color: $blackPrimary;
  width: fit-content;

  &:hover {
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.2);
  }

  &.disabled {
    cursor: default;
    color: $greyPrimary;

    ::v-deep .sb-icon .mask {
      background-color: $greyPrimary !important;
    }

    &:hover {
      color: $greyPrimary;
      
      ::v-deep .sb-icon .mask {
        background-color: $greyPrimary !important;
      }
    }
  }
}

.warning-note {
  margin: 0 0 20px 0;
  padding: 11px 15px 8px;
  border-radius: 5px;
  border: solid 1px #dcdccf;
  background-color: #fffef8;

  .emoji-fix {
    font-size: 14px !important;
  }

  p {
    font-size: 14px;
    color: #584f0b;
  }
}

.path {
  h3 {
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
    margin-bottom: 6px;
  }
}

::v-deep .no-label {
  label {
    display: none !important;
  }
}
</style>
